import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const alzheimers: AnswerPathTreeNode = {
  path: 'alzheimers',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredAlzheimerDetails }],
};
